import React from 'react'
import { parseInfrastructure } from '../helpers/propertyInfrastructure'

const PropertyInfrastructure = ({ value }) => {
  const { entries, items } = parseInfrastructure(value)

  if (!entries.length && !items.length) {
    return <p className="text-sm text-gray-500">Neuvedeno</p>
  }

  if (entries.length) {
    return (
      <dl className="overflow-hidden rounded-lg border border-gray-200 bg-white">
        {entries.map((entry) => (
          <div key={entry.label} className="grid gap-1 border-b border-gray-100 px-3 py-2.5 last:border-b-0 sm:grid-cols-[180px_1fr] sm:gap-4">
            <dt className="text-xs font-medium text-gray-500 sm:text-sm">{entry.label}</dt>
            <dd className="text-sm text-gray-900">{entry.value}</dd>
          </div>
        ))}
      </dl>
    )
  }

  return (
    <div className="flex flex-wrap gap-2">
      {items.map((item, index) => (
        <span key={`${item}:${index}`} className="rounded-full border border-gray-200 bg-gray-50 px-3 py-1.5 text-xs text-gray-700">
          {item}
        </span>
      ))}
    </div>
  )
}

export default PropertyInfrastructure
